import { OPERATOR_TYPES_2 } from 'dashboard/routes/dashboard/settings/automation/operators';

import { SUPERVISOR_ROLE } from './supervisorRole';

export const AUTOMATION_ROUTE_PERMISSIONS = [
  'administrator',
  SUPERVISOR_ROLE,
];

export const AUTOMATION_REGEX_OPERATORS = [
  ...OPERATOR_TYPES_2,
  {
    value: 'matches_regex',
    label: 'Matches regular expression',
  },
];
